import { getAwsAssets } from "@src/utils";
import Image from "@src/lib/Image";
import { useReducer, useState, useRef, useEffect } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import {
  idfyPostPurchageIdentityVerifyAction,
  polingSubmitIdfyDocAction,
} from "../../../../Content/store/actions";
import { hitDeeplinkExecutedV2 } from "@src/utils/hitDeeplink";
import { COMMON_DEEPLINK_ACTIONS } from "@src/utils/constants";
import { CONTENT_DEEPLINK_ACTIONS } from "../../../../Content/store/constants";
import { hitContentDeeplinkOld } from "../../../../Content/helpers/hitContentDeeplink";

const initialPolingSate = {
  isPolling: false,
  text: "Verification in progress...",
  isPending: false,
};

function reducer(state, action) {
  switch (action.type) {
    case "2": {
      return {
        ...state,
        isPolling: true,
        text: action.payload.btnText,
        isPending: true,
      };
    }
    case "3":{
       window.location.reload();
      return {
        ...state,
        isPolling: false,
        text: action.payload.btnText,
      }
    }
    case "4": {
      window.location.reload();
      return {
        ...state,
        isPolling: false,
        text: action.payload.btnText,
      };
    }
    case "5": {
      window.location.reload();
      return {
        ...state,
        isPolling: false,
        text: action.payload.btnText,
      };
    }
    case "6": {
      window.location.reload();
      return {
        ...state,
        isPolling: false,
        text: action.payload.btnText,
      };
    }
    default:
      return {
        ...state,
        isPolling: false,
        text: action.payload.btnText,
        isPending: false,
      };
  }
}

function PostPurchageIdfys({ postPurchageDetails }) {
  const [state, dispatch] = useReducer(reducer, initialPolingSate);
  const [isPolingDisabledBtn, setIsPolingDisabledBtn] = useState(false);
  const [resumeLink, setResumeLink] = useState(null);
  const intervalRef = useRef(null);
  const [inputField, setInputField] = useState({
    name: "",
    pan: "",
  });

  const dispatches = useDispatch();
  const metadata = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData
  );
  const orgCode = useSelector((state) => state?.persistedDataReducer?.orgDetails?.organization?.code);

  useEffect(() => {
    if (!state.isPolling) return;
    intervalRef.current = setInterval(() => {
      dispatches(
        polingSubmitIdfyDocAction({
          payload: { orgId: metadata?.orgId, courseId: metadata?.id },
          callback: callbackPollingSuccess,
        })
      );
    }, 3000);
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [state.isPolling]);

  const handleChnage = (e) => {
    const { name, value } = e.target;
    setInputField({
      ...inputField,
      [name]: name === "pan" ? value.toUpperCase() : value,
    });
  };

  const callbackPollingSuccess = (data) => {
    if (data?.status) {
      dispatch({
        type: `${data?.status}`,
        payload: data?.btnText,
      });
    }
  };

  const handleResumeClick = () => {
    if(postPurchageDetails?.redirect_url && !state?.isPending) {
      callbackSuccessIdentity({ isCall: true, url: postPurchageDetails?.redirect_url });
    } else if (resumeLink) {
      hitContentDeeplinkOld(
          CONTENT_DEEPLINK_ACTIONS.UTIL_WEBVIEW,
          {
            paramOne: `${resumeLink}`,
            paramFive: "1"
          },
          true,
          true
        );
      // window.open(resumeLink, "_blank");
      // hitDeeplinkExecutedV2(
      //   JSON.stringify({
      //     screen: COMMON_DEEPLINK_ACTIONS.UTIL_BROWSER,
      //     paramOne: resumeLink,
      //   }),
      //   JSON.stringify({
      //     screen: COMMON_DEEPLINK_ACTIONS.UTIL_BROWSER,
      //     paramOne: resumeLink,
      //   })
      // );
    }
  };

  useEffect(() => {
    if(postPurchageDetails?.redirect_url) {
      setResumeLink(postPurchageDetails?.redirect_url);
    }
  },[postPurchageDetails?.redirect_url])

  const callbackSuccessIdentity = ({ isCall, url }) => {
    if (isCall && url) {
      setResumeLink(url);
      setIsPolingDisabledBtn(true);
      const webUrl =  `https://${orgCode}.on-app.in/app/oc/${metadata?.id}` || '';
      const currentUrl = `${url}&redirect_url=${webUrl}`;
      hitContentDeeplinkOld(
          CONTENT_DEEPLINK_ACTIONS.UTIL_WEBVIEW,
          {
            paramOne: `${currentUrl}`,
            paramFive: "1"
          },
          true,
          true
        );
      // window.open(currentUrl, "_blank");
      //  hitDeeplinkExecutedV2(
      //   JSON.stringify({
      //     screen: COMMON_DEEPLINK_ACTIONS.UTIL_BROWSER,
      //     paramOne: currentUrl,
      //   }),
      //   JSON.stringify({
      //     screen: COMMON_DEEPLINK_ACTIONS.UTIL_BROWSER,
      //     paramOne: currentUrl,
      //   })
      // );
      dispatches(
        polingSubmitIdfyDocAction({
          payload: { orgId: metadata?.orgId, courseId: metadata?.id },
          callback: callbackPollingSuccess,
        })
      );
    }
    localStorage.setItem("idfySuccessDoc", "true");
  };

  const handleVerifyClick = () => {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    const payload = {
      name: inputField.name,
      panno: inputField.pan,
      courseId: metadata?.id || null,
    };

    if (panRegex.test(inputField.pan)) {
      dispatches(
        idfyPostPurchageIdentityVerifyAction({
          payload: payload,
          callback: callbackSuccessIdentity,
        })
      );
    } else {
      toast.error("Invalid PAN number");
    }
  };

  return (
    <div className="idfy-prepurchage">
      <div className="postpurchage">
        <div className="verification-logo">
          <Image
            src={postPurchageDetails?.isFailed ? getAwsAssets("idfys-failed.svg", "Overview") : getAwsAssets("docIdfys.svg", "Overview")}
            alt="idfys"
            width={64}
            height={64}
          />
        </div>
        <h2 className="postpurchage-itle">{postPurchageDetails?.isFailed ? "Aadhaar Verification Failed" : "Aadhaar Verification Required"}</h2>
        <p className="postpurchage-description">
          {postPurchageDetails?.message ||
            "Due to SEBI guidelines, Aadhaar Verification is mandatory before accessing the course content. Enter below details and continue"}
        </p>
        {postPurchageDetails?.subText || state?.isPending ? (
          <p className="postpurchage-description">
            {postPurchageDetails?.subText || "Please wait 10-15 seconds for the page to auto-confirm your verification status. You can then resume your journey if it was incomplete."}
          </p>
        ) : null}
        {state?.isPending || postPurchageDetails?.redirect_url ? (   <button
          className="postpurchage-button"
          onClick={handleResumeClick}
        >
          { "Resume Verification"}
        </button> ) : (<>

        <input
          className="postpurchage-input"
          onChange={handleChnage}
          name="name"
          type="text"
          value={inputField.name}
          placeholder="Enter your Name (as per PAN)"
          disabled={isPolingDisabledBtn}
        />
        <input
          className="postpurchage-input"
          onChange={handleChnage}
          name="pan"
          type="text"
          value={inputField.pan}
          placeholder="Enter your PAN no"
          disabled={isPolingDisabledBtn}
        />
        <button
          className="postpurchage-button"
          onClick={handleVerifyClick}
          disabled={
            !inputField.name ||
            !inputField.pan ||
            !!!postPurchageDetails?.btnEnabled ||
            isPolingDisabledBtn
          }
        >
          {postPurchageDetails?.btnText || "Verify Now"}
        </button> </>)}
      </div>
    </div>
  );
}

export default PostPurchageIdfys;
